import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  console.error('Missing Supabase environment variables. Check your .env file.');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});

// Edge functions base URL (kept for direct fetch fallback, e.g. PDF blob downloads)
export const FUNCTIONS_URL = `${supabaseUrl}/functions/v1`;

/**
 * Call a Supabase Edge Function using the SDK's built-in invoke().
 * This automatically attaches the correct Authorization + apikey headers,
 * handles token refresh, and works whether the user is logged in or not.
 */
export async function callFunction(name, body, method = 'POST') {
  const invokeOptions = { method };
  if (body && method !== 'GET') {
    invokeOptions.body = body;
  }

  const { data, error } = await supabase.functions.invoke(name, invokeOptions);

  if (error) {
    // FunctionsHttpError: the function returned a non-2xx response
    // Try to get the server-side error message
    let message = error.message || `Edge function ${name} failed`;
    try {
      if (error.context && typeof error.context.json === 'function') {
        const errBody = await error.context.json();
        message = errBody.error || errBody.message || message;
      }
    } catch (_) { /* ignore parse errors */ }
    throw new Error(message);
  }

  return data;
}

/**
 * Call a Supabase Edge Function via GET with optional query params.
 * Uses supabase.functions.invoke() so auth is handled automatically.
 */
export async function callFunctionGet(name, queryParams = {}) {
  const qs = new URLSearchParams(queryParams).toString();
  const functionName = qs ? `${name}?${qs}` : name;

  const { data, error } = await supabase.functions.invoke(functionName, {
    method: 'GET',
  });

  if (error) {
    let message = error.message || `Edge function ${name} failed`;
    try {
      if (error.context && typeof error.context.json === 'function') {
        const errBody = await error.context.json();
        message = errBody.error || errBody.message || message;
      }
    } catch (_) { /* ignore */ }
    throw new Error(message);
  }

  return data;
}
